import classNames from 'classnames';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { happySurveySvg, sadSurveySvg } from '../assets/images';

export interface SurveyButtonProps {
  checked?: boolean;
  type: 'happy' | 'sad';
  onClick?: () => void;
}

const SurveyButton: FC<SurveyButtonProps> = ({ type, checked, onClick }) => {
  const __ = useTranslation().t;

  const imgSrc = type === 'happy' ? happySurveySvg : sadSurveySvg;
  const text = type === 'happy' ? __('likedIt') : __('didntLike');

  return (
    <div
      className={classNames('oejr-btn-survey', checked && 'oejr-btn-survey-checked')}
      onClick={onClick}
    >
      <img src={imgSrc} alt="Emoji" />
      <span className="oejr-btn-survey-text">{text}</span>
    </div>
  );
};

export default SurveyButton;
